export const getDeliveryFormats = (t) => [
  {
    name: t('EDI'),
    value: 'EDI',
  },
  {
    name: t('EDI_AND_WEB'),
    value: 'EDI_AND_WEB',
  },
  {
    name: t('EMAIL_AND_WEB_MANUAL'),
    value: 'EMAIL_AND_WEB_MANUAL',
  },
  {
    name: t('EMAIL_AND_COMMAND'),
    value: 'EMAIL_AND_COMMAND',
  },
  {
    name: t('MANUAL_EMAIL'),
    value: 'MANUAL_EMAIL',
  },
  {
    name: t('PORTAL_INVOICING'),
    value: 'PORTAL_INVOICING',
  },
  {
    name: t('PORTAL_AND_EDI'),
    value: 'PORTAL_AND_EDI',
  },
  {
    name: t('PORTAL_UPLOAD'),
    value: 'PORTAL_UPLOAD',
  },
  {
    name: t('PORTAL_AND_AUTOPAY'),
    value: 'PORTAL_AND_AUTOPAY',
  },
  {
    name: t('PORTAL_EDI_AND_UPLOAD'),
    value: 'PORTAL_EDI_AND_UPLOAD',
  },
  {
    name: t('TEMPLATE_EMAIL'),
    value: 'TEMPLATE_EMAIL',
  },
  {
    name: t('TEMPLATE_AND_COMMAND'),
    value: 'TEMPLATE_AND_COMMAND',
  },
  {
    name: t('TEMPLATE_AUTOPAY'),
    value: 'TEMPLATE_AUTOPAY',
  },
  {
    name: t('TEMPLATE_PORTAL'),
    value: 'TEMPLATE_PORTAL',
  },
  {
    name: t('EDI_AND_EMAIL'),
    value: 'EDI_AND_EMAIL',
  },
];

export const CHARGE_TYPES = {
  LINE_HAUL: 'line_haul',
  FUEL_SURCHARGE: 'fuel_surcharge',
  CHASSIS_AND_PER_DIEM: 'chassis_and_per_diem',
  ALL_BUT_CHASSIS_AND_PER_DIEM: 'all_but_chassis_and_per_diem',
  ALL_BUT_LINE_HAUL_AND_FUEL_SURCHARGE: 'all_but_line_haul_and_fuel_surcharge',
  ALL: 'all',
};

export const CHARGES_BY_GROUPING = {
  ONE_PER_SHIPMENT: [CHARGE_TYPES.ALL],
  ONE_PER_SHIPMENT_PER_CHARGE_TYPE: [
    CHARGE_TYPES.LINE_HAUL,
    CHARGE_TYPES.FUEL_SURCHARGE,
    CHARGE_TYPES.ALL_BUT_LINE_HAUL_AND_FUEL_SURCHARGE,
  ],
  TWO_PER_SHIPMENT: [
    CHARGE_TYPES.CHASSIS_AND_PER_DIEM,
    CHARGE_TYPES.ALL_BUT_CHASSIS_AND_PER_DIEM,
  ],
  UNLIMITED: [
    CHARGE_TYPES.LINE_HAUL,
    CHARGE_TYPES.FUEL_SURCHARGE,
    CHARGE_TYPES.ALL_BUT_LINE_HAUL_AND_FUEL_SURCHARGE,
  ],
};
